import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=3f164748&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=3f164748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f164748",
  null
  
)

export default component.exports